export const APIConfig = {
  //initial calls
  requestApi: '/v1/user/request',
  logEvents: '/api/analytics/events',
  exitCheckout: '/v1/user/exit-checkout',
  healthService: '/v4/health/merchant',
  cart: {
    cartJs: '/cart.js',
    clearCart: '/cart/clear.js',
    abandonCart: '/v1/user/getcart',
    update: '/v1/user/cart',
    shopifyCart: '/v1/user/shopify-cart',
    updateCartAnalytics: '/v1/user/updateCart',
    createShopifyAbandonCart: '/v1/user/shopify-abandon-cart/create',
  },

  login: {
    validateToken: '/v1/user/validate/token',
    phoneNumber: '/v1/user/validate/user',
    verifyOtp: '/v1/user/verify/otp',
    resendOtp: '/v1/user/resend/otp',
    truecaller: '/v1/truecaller/verify',
    bpocLogin: '/v1/user/so-token',
  },

  address: {
    pincode: '/v1/user/address/zipcode',
    getAllAddress: '/v1/user/address/all?request_id=',
    addAddress: '/v1/user/address/add',
    editAddress: '/v1/user/address/edit',
    deleteAddress: '/v1/user/address/delete',
    postalCodes: '/v1/user/merchant/postal_codes',
    rgeocode: '/v1/user/address/rgeocode',
    suggestAddress: '/services/v3/address/suggest',
    addBillingAddress:'/v1/user/billing-address/add'
  },

  shipping: {
    shippingOptions: '/v1/user/merchant/shipping-options',
    shippingInfo: '/v1/user/merchant/order/shipping-info',
    merchantShippingRates: '/cart/shipping_rates.json?',
    shippingDiscount: '/v1/user/merchant/discount-shipping',
  },

  payment: {
    method: '/v1/payment/methods',
    capture: '/v1/payment/capture',
    resend: '/v1/payment/resend-payment-link',
    cards: {
      getAll: '/v1/payment/card/get-all',
      edit: '/v1/payment/card/edit',
      delete: '/v1/payment/card/delete',
      save: '/v1/payment/card/save',
      submitOtp: '/v1/payment/card/submit-card-otp',
      resendOtp: '/v1/payment/card/resend-card-otp',
      checkBin: '/v1/payment/card/checkbin',
      validateBinOffer: '/v1/payment/offer/validate-bin',
      removePaymentsAutoOffer: '/v1/payment/offer/remove-applied-auto-payment',
    },
    cardsEmi: {
      getAll: '/v1/payment/emi/get-all-plans',
      getAllEligibility: '/v1/payment/card/get-all-eligible',
      checkBinEligiblity: '/v1/payment/eligiblity/check-bin-eligiblity',
      noCostEligibility: '/v1/payment/eligible-emi-plans',
    },
    netBanking: {
      getBankList: '/v1/payment/netbanking/get-bank-list',
    },
    cashToPrepaid: '/payment/getPaymentData',
    upi: {
      getUPIHandles: '/v2/payment/upi-handles/',
    },
    otpBnpl: {
      verifyOtp: '/v1/payment/bnpl/verify-otp',
      resendOtp: '/v1/payment/bnpl/resend-otp',
    },
    otpWallet: {
      verifyOtp: '/v1/payment/wallet/verify-otp',
      resendOtp: '/v1/payment/wallet/resend-otp',
    },
    getCaptureDetails: '/v1/ms-interface/order/capture-details'
  },
  discount: {
    verifyCode: '/v1/user/merchant/order/discount',
    storeCredit: '/v1/user/wallet/getcredit',
    flitzCode: '/v1/user/wallet/get-code',
    availableOffers: '/v1/valid-offers',
  },
  giftCard: {
    getGiftCard: '/v1/giftCard/apply',
    removeGiftCards: '/v1/giftCard/remove',
    applyMultiple: '/v1/giftCard/apply/multiple',
    reapply: '/v1/giftCard/reapply',
  },
  rewards: {
    getRewards: '/v1/rewards/get',
    addBalance: '/v1/rewards/add-balance',
  },
  create: {
    create: '/v1/user/merchant/order/create',
    retry: '/v1/order/create/back',
    codBackApi: '/v1/order/create/onpl-back',
  },
  twidPay: {
    getRewards: '/v1/rewards/get',
    updateRewards: '/v1/rewards/update',
  },
  experiments: {
    getVariants: '/v3/experiment/api/get_user_variant',
    getExperiments: '/v3/experiment/api/experiments',
  },
  kp: {
    kpLoginToken: '/v3/auth/core-token/login',
  },
  gst: {
    validate: '/v1/user/gst/validate',
    set: '/v1/user/gst/set',
  },
  shopify_credits: {
    get: '/v1/store-credits/get',
    apply: '/v1/store-credits/apply',
    remove: '/v1/store-credits/remove',
  },
  thankyou: {
    getTotalOrders: '/v1/order/orders-count',
  },
};

export default APIConfig;
